












































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Input from '@/components/Input.vue';
import { namespace } from 'vuex-class';
import { BottomWrapper } from '../../BottomWrapper.vue';
import { PayChannelSuccessRate, TransStatement } from '@/common/api/model';
import { SYSTEM_MESSAGE_PREFIX, TransactionStatus, TransactionType } from '@/common/config';
import * as HardcodedTags from '@/common/tags';
import { formatMoney, notEmpty, waitFor } from '@/common/utils';
import { ChatWarning, PleasedUserInfo, TransactionInputEvent } from '@/common/types';
import FaCheckSquare from '@/components/icons/FaCheckSquare.vue';
import FaRegSquare from '@/components/icons/FaRegSquare.vue';
import RadioFilled from '@/components/icons/RadioFilled.vue';
import RadioEmpty from '@/components/icons/RadioEmpty.vue';
import TransactionItemWarning from './TransactionItemWarning.vue';
import UpdatedStatusWarning from './UpdatedStatusWarning.vue';
import { TRANSACTION_PREPOSITION_ENUM, TRANSACTION_STATUS_ENUM, TRANSACTION_STATUS_NAME_ENUM, TransactionStatusName, UpdatedStatusWarningVariant, checkTransactionWarning, TRANSACTION_TYPE_NAME_ENUM, isTxStatusPending, generateIssueMessage } from '@/common/transaction-utils';
import { ExternalTransactionKind, ExternalTransactionType } from '@/common/bot/enum/ExternalTransactionType';
import FaAngleRight from '@/components/icons/FaAngleRight.vue';
import { Bridge } from '@/common/bridge';
import { PLEASED_ARTICLE_ACTIONS } from '@/common/bot/flow-frameworks/ChatMessageActions.static';
import { GA_EVENT_CUSTOM_DIMENSION_ENUM, GA_EVENT_NAME_ENUM } from '@/common/gaHelper';
import { ChatWarnings } from '@/store/chatWarning/chatWarning.types';
import * as PleasedModel from '@/common/api/models.pleased';
import { ApplyMetadataAutomationExternEvent, ConnectToAgent, UserInputSubmittedTransactionForAiEvent } from '@/common/bot/types';
import { reportingService } from '@/common/reporting';
import * as PleasedApi from '@/common/api/api.pleased';
import { formatDate, formatDay, formatTime } from '@/common/date';
import Api from '@/common/api';
import { transactionParamsSwitch } from '@/common/sb-transaction.helpers';
import { checkMetadataRulesForTransaction, TransactionRefreshed } from '@/common/metadataRule.utils';
import { SelectedTransaction } from '@/store/transaction/transaction.store';
import { ExternalBotEvent } from '@/common/bot/enum/ExternalBotEvent';
import { randomId } from '@/common/bot/lib';
import { manualTransactionTriggerCheck, MatchedChatTrigger } from '@/common/bot/flow-frameworks/chat-trigger';
import LogPageEventMixin, { PAGE_TRACKING, PAGE_EVENTS } from '@/mixins/logPageEvent';
import { mixins } from 'vue-class-component';
import { analytics, GENERAL_EVENTS, syncLogs } from '@/common/logs';
import { BTN_EVTS } from '@/directives/trackClick';
import * as env from '@/common/environment';

const userModule = namespace('user');
const chatModule = namespace('chat');
const transactionModule = namespace('transaction');
const chatWarning = namespace('chatWarning');

@Component({
  components: {
    Input,
    BottomWrapper,
    FaCheckSquare,
    FaRegSquare,
    FaAngleRight,
    RadioFilled,
    RadioEmpty,
    TransactionItemWarning,
    UpdatedStatusWarning,
  },
  filters: {
    formatDate (value: any) {
      return formatDate(value);
    },
    formatDay (value: any) {
      return formatDay(value);
    },
    formatTime (value: any) {
      return formatTime(value);
    },
    formatMoney (value: number) {
      return formatMoney(value);
    },
  },
})
export default class Transaction extends mixins(LogPageEventMixin) {
  @Prop({ default: null }) readonly transactionsSavedData!: TransactionInputEvent | null;
  @Prop({ default: '' }) readonly transactionType!: TransactionType
  @Prop({ default: null }) readonly externalTransactionKinds!: ExternalTransactionKind[];
  @Prop() readonly connectConfig!: ConnectToAgent | null;
  @Prop({ default: () => [] }) readonly ticketFields!: PleasedModel.TicketField[];
  @Prop({ default: () => ({ subject: '', description: '', email: '' }) }) readonly requestInfo!: { subject: string, description: string, email: string };
  @Prop() readonly userSelections!: PleasedModel.UserSelection[];
  @Prop() readonly transactionFlow!: 'ai' | 'default';

  @userModule.State('greyListed') greyListed!: boolean;
  @userModule.State('pleasedUser') pleasedUser!: PleasedUserInfo;
  @userModule.State('country') country!: string;
  @userModule.State('userCountry') userCountry!: string;
  @userModule.Getter('currency') currency!: string;
  @userModule.Getter('pleasedUserDisplayName') pleasedUserDisplayName!: string;

  @chatModule.Mutation('updateExtraTransactionInfo') updateExtraTransactionInfo!: Function;
  @chatWarning.Getter('chatWarnings') chatWarnings!: ChatWarnings;

  @transactionModule.State('selectedTransactions') selectedTransactions!: SelectedTransaction[];
  @transactionModule.State('updatedTransactions') updatedTransactions!: { [key: string]: TransactionStatus }[];

  @transactionModule.Getter('transactionStatusFlags') transactionStatusFlags!: {
    isCheckingStatusForTransaction: boolean;
    showTransactionUpdatedWarning: boolean;
    shouldCheckStatusForDeposit: boolean;
    isTransactionStatusUpdatedSuccessfully: boolean;
  };
  @transactionModule.Getter('updatedTransactionsLength') updatedTransactionsLength!: number;
  @transactionModule.Getter('selectedTransactionAvailableForUpdate') selectedTransactionAvailableForUpdate!: TransStatement[];
  @transactionModule.Getter('allSelectedTransactionsUpdated') allSelectedTransactionsUpdated!: boolean;
  @transactionModule.Getter('hasOnlyPendingUpdatedTransactions') hasOnlyPendingUpdatedTransactions!: boolean;
  @transactionModule.Getter('hasOnlySuccessfulUpdatedTransactions') hasOnlySuccessfulUpdatedTransactions!: boolean;
  @transactionModule.Getter('getUpdatedTransactionStatus') getUpdatedTransactionStatus!:(tx: TransStatement) => TransactionStatusName | null;
  @transactionModule.Getter('updatedTransactionsNotification') updatedTransactionsNotification!: { type: UpdatedStatusWarningVariant, text: string };

  @transactionModule.Action('checkTransactionStatus') checkTransactionStatus!: () => Promise<void>;
  @transactionModule.Mutation('addSelectedTransactions') addSelectedTransactions!: (transactions: SelectedTransaction[]) => void;
  @transactionModule.Mutation('resetSelectedTransactions') resetSelectedTransactions!: () => void;
  @transactionModule.Mutation('setShowTransactionUpdatedWarning') setShowTransactionUpdatedWarning!: (show: boolean) => void;

  readonly TRANSACTION_PREPOSITION_ENUM = TRANSACTION_PREPOSITION_ENUM;
  readonly TRANSACTION_STATUS_ENUM = TRANSACTION_STATUS_ENUM;
  readonly TRANSACTION_STATUS_NAME_ENUM = TRANSACTION_STATUS_NAME_ENUM;

  readonly TRANSACTIONS_PER_PAGE = 5;

  // Refactoring TODO: move all state to vuex, same for most of methods here
  // Refactoring TODO: add switcher for "proceed" func, since method to use depends on id of button
  // Refactoring TODO: check improvements by propositions above, most code below should be moved

  transactions: TransStatement[] = [];
  transactionMethodSuccessRate: PayChannelSuccessRate[] | null = null;

  loading = false;
  showButtonLoader = false;

  currentPage = 1;
  totalPages = 1;

  expandedTrans: string[] = [];
  noneSelected: boolean = false;
  sentTransactionWarningTypes: string[] = [];
  sendRemedyShownMetric: boolean = false;

  isTicketCreationTriggered: boolean = false;
  lastCreatedDirectRequest: PleasedModel.TicketDetail | null = null;
  triggerTicketRequestMap: { [key: string]: PleasedModel.ActiveTicket[] } = {};

  errInfo = {
    isErr: false,
    message: '',
  };

  localTransactions: TransStatement[] = [];

  get title () {
    if (this.lastCreatedDirectRequest) {
      return this.$t('global.ticket.ticket_created', { ticketId: this.lastCreatedDirectRequest.id }).toString();
    }

    if (this.isNoRecord) {
      return this.$t('page.issue.transaction.none');
    }

    const iSingleExternalTransactionType = this.externalTransactionKinds.length === 1;

    const transactionTypeTitle = iSingleExternalTransactionType
      ? this.$t(
        `page.issue.transaction.title.${this.externalTransactionKinds[0].toLowerCase()}`
      )
      : this.$t('page.issue.transaction.title.transaction');

    return `${this.$t('page.issue.transaction.title.select')} ${transactionTypeTitle}`;
  }

  get selectedTransactionWithWarnings () {
    const transactionWarnings = (this.selectedTransactions || []).map((transaction) => checkTransactionWarning({
      transaction,
      transactionMethodSuccessRate: this.transactionMethodSuccessRate,
      type: this.transactionType,
      chatWarnings: this.chatWarnings,
    }));

    return transactionWarnings.filter((warning) => warning.show);
  }

  get isSelectedTransactionWithWarning () {
    return !!this.selectedTransactionWithWarnings.length;
  }

  get showLoadingInButton () {
    return this.showButtonLoader || this.transactionStatusFlags.isCheckingStatusForTransaction;
  }

  get buttonLoadingText () {
    if (this.hasMetadataRules) {
      return this.$t('global.please_wait');
    }

    return this.$tc('page.issue.transaction.checking_deposit_status', this.selectedTransactions.length);
  }

  get isPendingDepositTransactions () {
    return this.externalTransactionKinds.includes(ExternalTransactionType.DEPOSITS_PENDING);
  }

  get triggerTicketCreation () {
    const { triggerTicketCreation } = this.connectConfig || {};

    return !!triggerTicketCreation && this.selectedTransactions.length > 0;
  }

  get ticketCreationResponseMessage () {
    return this.connectConfig?.ticketCreationResponseMessage;
  }

  get triggerTicketCreationError () {
    if (!this.triggerTicketCreation) {
      return '';
    }

    const isSelectedTransactionAlreadyReported = this.selectedTransactions.some((tx) => {
      const { tradeId } = tx;
      return this.triggerTicketRequestMap[tradeId]?.length > 0;
    });

    if (isSelectedTransactionAlreadyReported) {
      return this.$t('page.issue.transaction.duplicate_direct_ticket_error').toString();
    }

    return '';
  }

  get hasMetadataRules () {
    return this.connectConfig?.enableMetadataRules && this.connectConfig?.metadataRules?.length;
  }

  get isSingleTransactionSelectMode () {
    const { triggerTicketCreation } = this.connectConfig || {};

    const isAiFlow = this.transactionFlow === 'ai';

    // if triggerTicketCreation is not set, then we don't need to check
    // for unsettled bet limitation (1 transaction per request)
    return !!triggerTicketCreation || this.hasMetadataRules || isAiFlow;
  }

  get transactionExtraFields () {
    return [{
      extraFieldKey: 'Transaction',
      extraFieldValue: this.selectedTransactions.reduce((acc, cur) => {
        const msg = `${this.actionType} ${this.preposition} ${cur.counterAuthority ? cur.counterAuthority : cur.counterFull} ${formatMoney(cur.amount)} ${this.currency}`;
        return acc ? `${acc} / ${msg}` : `${msg}`;
      }, ''),
    }, {
      extraFieldKey: 'Transaction ID',
      extraFieldValue: this.selectedTransactions.reduce((acc, cur) => acc ? `${acc} / ${cur.tradeId}` : `${cur.tradeId}`, ''),
    }];
  }

  get buttons () {
    const proceedButton = {
      name: this.isSelectedTransactionWithWarning ? this.$t('page.issue.transaction.proceed_anyway') : this.$t('page.guest.button.proceed'),
      id: 'proceed' as const,
      className: this.isSelectedTransactionWithWarning ? 'secondary' : '',
      disabled: !this.canProceed,
    };

    const checkStatusButton = {
      name: this.$tc('page.issue.transaction.check_deposit_status', this.selectedTransactions.length),
      id: 'checkStatus' as const,
    };

    const cancelButton = { name: this.$t('page.issue.transaction.cancel_request'), id: 'cancel' as const };
    const transactionsButton = { name: this.$t('page.issue.transaction.transactions'), id: 'transactions' as const, appendIcon: FaAngleRight };
    const contactSupportButton = { name: this.$t('page.issue.transaction.contact_support'), id: 'proceed' as const, className: !this.hasOnlyPendingUpdatedTransactions ? 'secondary' : '' };
    const needMoreHelpButton = {
      // TODO: make separate row in i18n
      name: this.$t('article.feedback.button.need_more_help'),
      id: 'go-to-ticket',
      isActive: false,
      className: 'secondary',
    };
    const metadataRulesProceed = {
      name: this.$t('page.guest.button.proceed'),
      id: 'metadata-rule-check' as const,
      className: 'secondary',
    };
    const aiFlowProceedButton = {
      name: this.$t('page.guest.button.proceed'),
      id: 'ai-flow-proceed' as const,
      className: 'secondary',
      disabled: !this.canProceed,
    };

    // TODO: add new button here for AI Flow. If "flow" === "AI" then show it, also make it single select transaction

    const endChatButton = { name: this.$t('global.end_chat'), id: 'end-chat' as const, isActive: true };

    if (this.transactionFlow === 'ai') {
      return [
        aiFlowProceedButton,
      ];
    }

    if (this.isTicketCreationTriggered) {
      if (this.errInfo.isErr) {
        return [
          endChatButton,
        ];
      }

      return [needMoreHelpButton, endChatButton];
    }

    if (this.triggerTicketCreation) {
      if (this.triggerTicketCreationError) {
        return [
          endChatButton,
        ];
      }

      return [{
        name: this.$t('page.issue.transaction.submit_request'),
        id: 'direct-trigger-ticket-creation',
        isActive: true,
      }];
    }

    if (this.hasOnlySuccessfulUpdatedTransactions) {
      return [transactionsButton];
    }

    if (this.transactionStatusFlags.shouldCheckStatusForDeposit) {
      return [checkStatusButton];
    }

    if (this.hasOnlyPendingUpdatedTransactions) {
      return [contactSupportButton];
    }

    if (this.allSelectedTransactionsUpdated) {
      return [contactSupportButton, transactionsButton];
    }

    if (this.hasMetadataRules && !this.isNoRecord) {
      return [metadataRulesProceed];
    }

    return [
      proceedButton,
      ...(this.isSelectedTransactionWithWarning ? [cancelButton] : []),
    ];
  }

  get actionType () {
    return TransactionType[this.transactionType];
  }
  get preposition () {
    return this.TRANSACTION_PREPOSITION_ENUM[this.transactionType];
  }
  get isNoRecord () {
    return this.transactions.length === 0;
  }
  get canProceed () {
    return this.selectedTransactions.length || this.noneSelected || this.isNoRecord;
  }
  get operator () {
    return this.transactionType === TransactionType.Deposit ? '+' : '-';
  }
  get isDepositList () {
    return this.transactionType === TransactionType.Deposit;
  }

  get transactionsToShow () {
    return this.localTransactions.length ? this.localTransactions : this.transactions;
  }

  get defaultRemedyGaParams () {
    const { isTransactionStatusUpdatedSuccessfully } = this.transactionStatusFlags;

    return {
      event_category: 'Transaction',
      ...(isTransactionStatusUpdatedSuccessfully !== null
        ? {
          [GA_EVENT_CUSTOM_DIMENSION_ENUM.REMEDY_TRANSACTION_UPDATED_SUCCESSFULLY]: isTransactionStatusUpdatedSuccessfully,
        }
        : {}),
    };
  }

  get showNoneSelected () {
    const {
      showTransactionSelectorNoneOption = false,
      showTransactionSelectorNoneOptionForAI = false,
      showTransactionSelectorNoneOptionForMetaAuto = false,
    } = env.get('features') || {};

    if (this.transactionFlow === 'ai') {
      return showTransactionSelectorNoneOptionForAI;
    }

    if (this.hasMetadataRules) {
      return showTransactionSelectorNoneOptionForMetaAuto;
    }

    return showTransactionSelectorNoneOption;
  }

  get [PAGE_TRACKING] () {
    return {
      name: PAGE_EVENTS.CONNECT_REQUEST_TRANSACTION,
      metadata: {
        transactionType: this.actionType,
        transactionSubTypes: this.externalTransactionKinds,
      },
    };
  }

  created () {
    document.title = 'Transactions';

    if (this.transactionsSavedData) {
      this.resetSelectedTransactions();
      this.addSelectedTransactions(this.transactionsSavedData.selectedTransIssue);
    }

    this.loadTransactions();
    this.loadPaymentsCheck();

    const key = `local_tx_${this.transactionType === TransactionType.Deposit ? 'deposits' : 'withdrawals'}`;
    const localTransactions = JSON.parse(localStorage.getItem(key) || '[]');
    this.localTransactions = localTransactions;
  }

  beforeDestroy () {
    this.resetSelectedTransactions();
  }

  async getTransactionHistory (pageNo: number = this.currentPage) {
    const transactionSubTypes = this.externalTransactionKinds as ExternalTransactionKind[];

    const transactionSubTypeCodes =
      transactionSubTypes
        .map(transactionSubType =>
          transactionParamsSwitch.match(transactionSubType).status
        )
        .filter(v => !!v)
        .join(',');

    const params = transactionSubTypeCodes ? {
      type: this.transactionType,
      statuses: transactionSubTypeCodes,
    } : {};

    const transactions = await Api.getTransactionHistory({
      ...params,
      pageSize: this.TRANSACTIONS_PER_PAGE,
      pageNo,
      _t: +new Date(),
    });

    this.totalPages = Math.ceil((transactions.data.totalNum || 1) / this.TRANSACTIONS_PER_PAGE);

    return transactions.data.statements;
  }

  async loadTransactions () {
    this.loading = true;
    this.transactions = await this.getTransactionHistory(this.currentPage);
    this.loading = false;
  }

  async loadPaymentsCheck () {
    // Payment alert check
    const transactionMethodIssueCheckEnabled = true;
    return (transactionMethodIssueCheckEnabled
      ? Api.getAlertInfo(
        this.transactionType === TransactionType.Withdrawal
          ? 'withdraw'
          : 'deposit'
      )
        .then(x => (x.bizCode === 10000 ? x.data : null))
        .catch(() => null)
      : Promise.resolve(null)
    ).then(data => (this.transactionMethodSuccessRate = data));
  }

  selectTransaction (transaction: TransStatement) {
    this.noneSelected = false;

    analytics.trackClick({
      name: BTN_EVTS.CONNECT_REQUEST_TRANSACTION_SELECTED,
      selection: transaction.tradeId,
      metadata: {
        transaction,
        transactionType: this.actionType,
        selected: !this.isTransactionSelected(transaction),
      },
    });

    this.addSelectedTransactions([
      { ...transaction, txPage: this.currentPage },
      ...(this.isSingleTransactionSelectMode ? [...this.selectedTransactions] : []),
    ]);
  }

  expandTrans (tradeId: string) {
    const index = this.expandedTrans.indexOf(tradeId);
    const exist = index !== -1;
    if (exist) {
      this.expandedTrans.splice(index, 1);
    } else {
      this.expandedTrans.push(tradeId);
    }
  }

  selectNone () {
    if (this.noneSelected) {
      this.noneSelected = false;
    } else {
      this.resetSelectedTransactions();
      this.noneSelected = true;
    }
  }

  isTransactionSelected (transaction: TransStatement) {
    return this.selectedTransactions.some((item) => item.tradeId === transaction.tradeId);
  }

  goToTransactions () {
    Bridge.goToAction(PLEASED_ARTICLE_ACTIONS.GO_TRANSACTIONS);
  }

  async handleMetadataRulesCheck () {
    let transaction: TransactionRefreshed = this.selectedTransactions[0];
    this.showButtonLoader = true;

    const isTxPending = isTxStatusPending(transaction.status);

    if (isTxPending) {
      await waitFor(3000);
      const updatedTransactions = await this.getTransactionHistory(transaction.txPage);
      const newTxStatus = updatedTransactions.find((tx) => tx.tradeId === transaction.tradeId)?.status || transaction.status;
      transaction = { ...transaction, newStatus: newTxStatus };

      const updatedStatusName = this.TRANSACTION_STATUS_NAME_ENUM[newTxStatus].toLowerCase();
      this.$gtag.event(GA_EVENT_NAME_ENUM.METADATA_TRANSACTION_NEW_STATUS_ + updatedStatusName, {
        [GA_EVENT_CUSTOM_DIMENSION_ENUM.TRADE_ID]: transaction.tradeId,
      });
    }

    const transactionMetadataParams = {
      tradeId: transaction.tradeId,
      userId: this.pleasedUser.foreignId,
      countryCode: this.country,
    };

    const transactionMetadata: PleasedModel.TransactionMetadata = await PleasedApi.getTransactionMetadata(
      transactionMetadataParams
    ).catch((err: Error) => {
      analytics.track({
        name: GENERAL_EVENTS.CONNECT_REQUEST_TRANSACTION_METADATA_CHECK_EXTERNAL_API_ERROR,
        metadata: { name: err?.name, message: err?.message, err },
      });

      return {
        tradeNumber: null,
        transactionNumber: null,
        sessionId: null,
        isNameConfirmed: null,
      };
    });

    analytics.track({
      name: GENERAL_EVENTS.CONNECT_REQUEST_TRANSACTION_METADATA_CHECK_EXTERNAL_API_RESULT,
      selection: transaction.tradeId,
      metadata: {
        transaction,
        params: transactionMetadataParams,
        response: transactionMetadata,
      },
    });

    const checkMetadataRulesParams = {
      transaction,
      transactionType: this.transactionType,
      connectConfig: this.connectConfig,
      userGreyListed: this.greyListed,
      userFields: {
        email: this.requestInfo.email || this.pleasedUser.email,
        phone: this.pleasedUser.phone,
        name: this.pleasedUserDisplayName,
        foreignId: this.pleasedUser.foreignId,
      },
      transactionMetadata,
    };

    const response = checkMetadataRulesForTransaction(checkMetadataRulesParams);

    analytics.track({
      name: GENERAL_EVENTS.CONNECT_REQUEST_TRANSACTION_METADATA_CHECK_RESULT,
      selection: transaction.tradeId,
      metadata: {
        transaction,
        params: checkMetadataRulesParams,
        response: response,
      },
    });

    const { responseText, rule } = response || {};

    const event: ApplyMetadataAutomationExternEvent = {
      id: randomId(),
      type: ExternalBotEvent.APPLY_METADATA_AUTOMATION,
      payload: {
        supportOptions: this.connectConfig,
        metadataAutomationMessage: responseText,
        metadataAutomationRule: rule,
        transaction,
      },
    };

    this.showButtonLoader = false;

    return event;
  }

  async refreshTransactionStatus () {
    const updatedTransactions = await this.checkTransactionStatus();
    this.$emit('remedy-transaction:input', { updatedTransactions });
  }

  // TODO: maybe move all functions logic here separately to methods and use in switcher
  async proceed (selectedButton: { id: string }) {
    const firstTransaction = this.selectedTransactions[0];

    if (selectedButton.id === 'cancel') {
      if (this.isSelectedTransactionWithWarning) {
        // take first warning
        const transactionWarning = this.selectedTransactionWithWarnings[0];

        this.$gtag.event(GA_EVENT_NAME_ENUM.CANCEL_REQUEST_TRANSACTION_WARNING, {
          'event_category': 'Transaction',
          [GA_EVENT_CUSTOM_DIMENSION_ENUM.TRANSACTION_WARNING_TYPE]: transactionWarning.type,
        });

        analytics.trackClick({
          name: BTN_EVTS.CONNECT_REQUEST_TRANSACTION_WARNING_CANCEL,
          selection: firstTransaction?.tradeId,
          metadata: {
            transactionWarning,
            transaction: firstTransaction,
          },
        });
      }

      this.$emit('support-request:cancel');
      return;
    }

    if (selectedButton.id === 'end-chat') {
      analytics.trackClick({
        name: BTN_EVTS.CONNECT_REQUEST_TRANSACTION_END_CHAT,
        selection: firstTransaction?.tradeId,
        metadata: {
          transactions: this.selectedTransactions,
        },
      });

      this.$emit('end-chat');
      return;
    }

    if (selectedButton.id === 'direct-trigger-ticket-creation') {
      analytics.trackClick({
        name: BTN_EVTS.CONNECT_REQUEST_TRANSACTION_DIRECT_TICKET_CREATION,
        selection: firstTransaction?.tradeId,
        metadata: {
          transactions: this.selectedTransactions,
        },
      });

      this.directTriggerTicketCreation();
      return;
    }

    if (selectedButton.id === 'go-to-ticket') {
      // Single transaction mode for this button
      analytics.trackClick({
        name: BTN_EVTS.CONNECT_REQUEST_TRANSACTION_GO_TO_TICKET,
        selection: firstTransaction?.tradeId,
        metadata: {
          transaction: firstTransaction,
          ticketId: this.lastCreatedDirectRequest?.id,
        },
      });

      this.$emit('open-active-conversation', this.lastCreatedDirectRequest);
      return;
    }

    if (selectedButton.id === 'checkStatus') {
      this.$gtag.event(GA_EVENT_NAME_ENUM.REMEDY_TRANSACTION_RUN, this.defaultRemedyGaParams);
      analytics.trackClick({
        name: BTN_EVTS.CONNECT_REQUEST_TRANSACTION_CHECK_STATUS,
        selection: firstTransaction?.tradeId,
        metadata: {
          transactionForUpdate: this.selectedTransactionAvailableForUpdate,
        },
      });

      this.refreshTransactionStatus();
      return;
    }

    if (selectedButton.id === 'transactions') {
      if (this.updatedTransactionsLength > 0) {
        this.$gtag.event(GA_EVENT_NAME_ENUM.GO_TO_TRANSACTIONS_AFTER_REMEDY, this.defaultRemedyGaParams);
      }

      analytics.trackClick({
        name: BTN_EVTS.CONNECT_REQUEST_TRANSACTION_GO_TO_TRANSACTIONS,
        selection: firstTransaction?.tradeId,
        metadata: {
          selectedTransactions: this.selectedTransactions,
          updatedTransactions: this.updatedTransactions,
          afterRemedy: this.updatedTransactionsLength > 0,
        },
      });

      await syncLogs();

      this.goToTransactions();
      return;
    }

    if (selectedButton.id === 'ai-flow-proceed') {
      const emitAiFlowEvent = (metadata: PleasedModel.ExtendedTransStatement): void => {
        const event: UserInputSubmittedTransactionForAiEvent = {
          id: randomId(),
          type: ExternalBotEvent.USER_SUBMIT_INPUT_TRANSACTION_FOR_AI,
          payload: {
            transactionType: this.transactionType,
            transactionMetadata: metadata,
          },
        };

        console.log('transaction ai event', event);
        this.$emit('transaction:ai-flow-input', event);
      };

      const transaction = this.selectedTransactions[0];
      if (this.noneSelected || !transaction) return emitAiFlowEvent({ transactionNotSelected: true });

      const transactionInfo = transaction ? await PleasedApi.getTransactionMetadata({
        tradeId: transaction.tradeId,
        userId: this.pleasedUser.foreignId,
        countryCode: this.country,
      }) : {};

      const transactionMetadata = {
        transactionNotSelected: false,
        SELECTED_ENTITY_TYPE: this.actionType.toUpperCase(),
        ...transaction,
        ...transactionInfo,
      };

      return emitAiFlowEvent(transactionMetadata);
    }

    this.updateExtraTransactionInfo(this.transactionExtraFields);

    analytics.trackClick({
      name: BTN_EVTS.CONNECT_REQUEST_TRANSACTION_PROCEED,
      selection: firstTransaction?.tradeId,
      metadata: {
        transactions: this.selectedTransactions,
        updatedTransactions: this.updatedTransactions,
        afterRemedy: this.updatedTransactionsLength > 0,
      },
    });

    if (!this.canProceed) return;

    await this.checkTransactionTrigger();

    if (this.updatedTransactionsLength > 0) {
      this.$gtag.event(GA_EVENT_NAME_ENUM.CONTACT_SUPPORT_AFTER_REMEDY, this.defaultRemedyGaParams);
    }

    const issues = this.selectedTransactions.map(tx => generateIssueMessage({
      type: this.transactionType,
      transaction: tx,
    }));

    const transactionInputEvent = {
      type: this.transactionType,
      issues,
      none: this.noneSelected,
      meta: this.transactionExtraFields,
      empty: this.isNoRecord,
      selectedTransIssue: this.selectedTransactions,
    };

    if (selectedButton.id === 'metadata-rule-check') {
      analytics.trackClick({
        name: BTN_EVTS.CONNECT_REQUEST_TRANSACTION_METADATA_CHECK,
        selection: firstTransaction?.tradeId,
        metadata: { transaction: firstTransaction },
      });

      const metadataEvent = await this.handleMetadataRulesCheck();

      this.$emit('transaction:metadata-input', {
        transactionEvent: transactionInputEvent,
        metadataEvent,
      });
    } else {
      this.$emit('transaction:input', transactionInputEvent);
    }
  }

  getSelectionIssueText (transaction: TransStatement) {
    const authority = transaction.counterAuthority ? transaction.counterAuthority : transaction.counterFull;
    const msg = `${this.actionType} ${authority ? this.preposition : ''} ${authority || ''} ${formatMoney(transaction.amount)} ${this.currency} (transaction id: ${transaction.tradeId})`;

    return msg;
  }

  async directTriggerTicketCreation () {
    const { category, title } = this.connectConfig || {};
    const transactionId = this.selectedTransactions[0].tradeId;

    const openedTickets = await PleasedApi.getActiveConversations({ onlyActive: true, transactionId });

    if (openedTickets.tickets.length > 0) {
      Vue.set(this.triggerTicketRequestMap, transactionId, openedTickets.tickets);
      return;
    }

    reportingService.openRequestClicked();

    const transactionUserSelections = this.selectedTransactions.map((tx) => ({
      createdAt: `${Date.now()}`,
      message: `${SYSTEM_MESSAGE_PREFIX} ${this.t('chat.user.issue.part')}: ${this.getSelectionIssueText(tx)}`,
    }));

    // For now we'll support only 1 transaction per request
    const subjectIds = `(Id${this.selectedTransactions.length > 1 ? 's' : ''}: ${this.selectedTransactions.map((tx) => tx.tradeId).join(', ')})`;
    const subject = `${category} - ${title} - ${subjectIds}`;
    const hadAiConversation = this.connectConfig?.aiConversation;

    const tags = [
      HardcodedTags.DIRECT_TICKET_TAG,
    ].filter(notEmpty);

    PleasedApi.createTicket({
      subject,
      // TODO: move to i18n
      description: 'Direct Ticket Creation Request',
      recipientAddress: this.requestInfo.email,
      ticketFields: this.ticketFields,
      userSelections: [...this.userSelections, ...transactionUserSelections],
      userLogs: reportingService.getLogs(),
      tags,
      transactionId,
      chatbotSessionId: analytics.sessionId,
      ...(hadAiConversation ? { aiSessionId: analytics.sessionId } : {}),
    }).then((res) => {
      this.lastCreatedDirectRequest = res;
      this.isTicketCreationTriggered = true;
      this.$emit('direct-open-request', res);
    }).catch(e => {
      const error: Error = e;
      this.errInfo.isErr = true;
      this.errInfo.message = error.message;
    });
  }

  async checkTransactionTrigger () {
    this.showButtonLoader = true;

    const matchedTxTriggers: MatchedChatTrigger[] = [];
    const transactionChecks = this.selectedTransactions.map(transaction =>
      manualTransactionTriggerCheck(
        {
          userCountry: this.userCountry,
          transaction,
          transactionType: TRANSACTION_TYPE_NAME_ENUM[this.transactionType],
        },
        matched => {
          if (matched) matchedTxTriggers.push(matched);
        }
      )
    );

    await Promise.all(transactionChecks);

    const firstMatchedTrigger = matchedTxTriggers[0];
    console.log({
      firstMatchedTrigger,
      matchedTxTriggers,
    });

    if (firstMatchedTrigger) {
      this.$emit('show-overlay-trigger', firstMatchedTrigger);
    }

    this.showButtonLoader = false;
  }

  @Watch('selectedTransactionWithWarnings')
  onSelectedTransactionWithWarningsChange (transactionWarnings: ChatWarning[]) {
    transactionWarnings.forEach((transactionWarning) => {
      if (transactionWarning && transactionWarning.type && !this.sentTransactionWarningTypes.includes(transactionWarning.type)) {
        this.$gtag.event(GA_EVENT_NAME_ENUM.TRANSACTION_WARNING_SHOWN, {
          'event_category': 'Transaction',
          [GA_EVENT_CUSTOM_DIMENSION_ENUM.TRANSACTION_WARNING_TYPE]: transactionWarning.type,
        });

        analytics.track({
          name: GENERAL_EVENTS.CONNECT_REQUEST_TRANSACTION_WARNING_SHOWN,
          metadata: {
            transactionType: this.actionType,
            warning: transactionWarning,
          },
        });

        this.sentTransactionWarningTypes.push(transactionWarning.type);
      }
    });
  }

  @Watch('transactionStatusFlags.shouldCheckStatusForDeposit')
  onShouldCheckStatusForDepositChange (shouldCheckStatusForDeposit: boolean) {
    if (shouldCheckStatusForDeposit && !this.sendRemedyShownMetric) {
      this.$gtag.event(GA_EVENT_NAME_ENUM.REMEDY_TRANSACTION_SHOWN, this.defaultRemedyGaParams);

      analytics.track({
        name: GENERAL_EVENTS.CONNECT_REQUEST_TRANSACTION_REMEDY_SHOWN,
        selection: this.selectedTransactionAvailableForUpdate[0]?.tradeId,
        metadata: {
          transactionType: this.actionType,
          transactionSubTypes: this.externalTransactionKinds,
        },
      });

      this.sendRemedyShownMetric = true;
    }
  }

  @Watch('currentPage')
  onPageChange () {
    this.loadTransactions();
  }
}
